module.exports = __webpack_public_path__ + "static/media/forward_email.4afee9df.svg";